{
  "name": "shiva-exploit",
  "version": "2.4.3",
  "scripts": {
    "ng": "ng",
    "start:integration": "ng serve -o --configuration=integration",
    "start:prod": "ng serve -o --configuration=prod",
    "start:local": "ng serve -o --configuration=local",
    "linter": "ng lint --fix",
    "build": "ng build",
    "build:integration": "ng build --output-hashing=all --configuration=integration,gnvert",
    "build:prod": "ng build --output-hashing=all --configuration=prod,gnvert",
    "build:local": "ng build --configuration=gnvert,local",
    "build:gnvert": "ng build --configuration=gnvert",
    "swagger-gen": "ng-swagger-gen -c ng-swagger-sdk.json && node swagger-post-process.js",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.5",
    "@angular/cdk": "^22.1.5",
    "@angular/cli": "^22.1.7",
    "@angular/common": "^22.1.5",
    "@angular/compiler": "^22.1.5",
    "@angular/compiler-cli": "^22.1.5",
    "@angular/core": "^22.1.5",
    "@angular/forms": "^22.1.5",
    "@angular/material": "^22.1.5",
    "@angular/material-moment-adapter": "^22.1.5",
    "@angular/platform-browser": "^22.1.5",
    "@angular/platform-browser-dynamic": "^22.1.5",
    "@angular/router": "^22.1.5",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@ngrx/schematics": "^18.0.0",
    "@ngx-translate/core": "^17",
    "@ngx-translate/http-loader": "^17",
    "@okta/okta-angular": "^6.5.1",
    "@okta/okta-auth-js": "^7.13.1",
    "@okta/okta-signin-widget": "^7.28.2",
    "@types/file-saver": "^2.0.1",
    "@types/node": "22",
    "core-js": "^3.17.2",
    "file-saver": "^2.0.2",
    "jwt-decode": "4",
    "moment": "^2.30.1",
    "ngx-logger": "^5.0.12",
    "popper.js": "1.14.7",
    "rxjs": "^7.8.0",
    "simple-crypto-js": "^3.0.1",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.0"
  },
  "overrides": {
    "@babel/runtime": "^7.26.10",
    "qs": "^6.16.0"
  },
  "devDependencies": {
    "@angular/build": "^22.1.7",
    "@angular/language-service": "^22.1.5",
    "@types/jasmine": "~5.1.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~5.5.0",
    "jasmine-spec-reporter": "~5.0.0",
    "json-server": "^0.17.3",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-swagger-gen": "^2.3.1",
    "resize-observer-polyfill": "^1.5.1",
    "ts-node": "~10.9.0",
    "typescript": "~6.0.3"
  }
}
